module.exports = __webpack_public_path__ + "static/media/4m.e8040c5e.png";